<script lang="ts" setup>
const resultProduct = ref(5);

function handleResize() {
  if (document.body.clientWidth > 900) {
    resultProduct.value = 5;
  } else if (
    document.body.clientWidth > 767 &&
    document.body.clientWidth <= 900
  ) {
    resultProduct.value = 3;
  } else {
    resultProduct.value = 2;
  }
}

onMounted(() => {
  handleResize();
  window.addEventListener("resize", handleResize);
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});
</script>

<template>
  <div class="carousel skeleton">
    <div
      class="item-product-carousel"
      v-for="item in resultProduct"
      :key="item"
    >
      <div class="product-image-container-fluid"></div>
      <div class="product_title"></div>
      <div class="price-html"></div>
    </div>
  </div>
</template>
